export function isImage(url) {
    if (!url) return false;
    const clean = String(url).split(/[?#]/)[0];
    return /\.(jpe?g|png|webp|avif|gif|svg|bmp|tiff?)$/i.test(clean);
}

export function getFileExtension(url) {
    if (!url) return '';
    const clean = String(url).split(/[?#]/)[0];
    const parts = clean.split('.');
    if (parts.length < 2) return '';
    return parts[parts.length - 1].toLowerCase();
}
